var _ = require('lodash');
var slider = require('./slider');
require('angular');
require('./services');

var controllers = angular.module('tristarApp.controllers', ['tristarApp.services'])

// AppController
controllers.controller('AppController', ['$scope', function($scope) {

}]);

// HomeController
controllers.controller('HomeController', ['$scope', function($scope) {
	// initialize the hero slider
	slider.initHeroSlider();
}]);

// SpecialsController
controllers.controller('SpecialsController', [
	'$scope',
	'$timeout',
	'ProductService',
	function($scope, $timeout, ProductService) {
		$scope.title = 'Tristar Specials';
		$scope.items = ProductService.specials;

		// fetch the specials
		ProductService.getSpecials()
			.then(function(items) {
				$scope.items = items.splice(0, 30);
				ProductService.specials = $scope.items;
				$timeout(function() {
					slider.initSpecialsSlider();
					$scope.showSlider = true;
				});
			}, function(err) {
				console.error('Unable to fetch specials', err);
			});
	}
]);

controllers.controller('ProductsController', [
	'$scope',
	'ProductService',
	'Analytics',
	function($scope, ProductService, Analytics) {

		$scope.search = ProductService.getSearchFilters() || {};

		$scope.selected = _.merge({}, $scope.search);
		$scope.searchResults = ProductService.searchResults;

		$scope.startLoading = function() {
			$scope.loading = true;
			console.info('loading starts ...');
		}
		$scope.endLoading = function() {
			$scope.loading = false;
			console.info('loading ends ...');
		}

		// get categories
		ProductService.getCategories()
			.then(function(categories) {
				$scope.categories = [{
					key: '',
					value: 'All Categories'
				}].concat(categories);
				if (!$scope.search.category) {
					$scope.search.category = $scope.categories[0].key;
				}

				// initialize the search when the controller loads for the first time on page load
				// the reason to initialize within this promise is becauase we call getProducts to get categories
				// so products are already being cached
				if (!$scope.searchResults) {
					$scope.doSearch();
				}

			}, function(err) {
				console.error('Unable to get categories', err);
			});


		// perform the search
		$scope.doSearch = function() {
			$scope.startLoading();
			Analytics.trackEvent('website', 'product-search', 'data', $scope.formData);
			ProductService.getSearchResults({
					name: $scope.search.name || '',
					category: $scope.search.category || ''
				})
				.then(function(results) {
					$scope.endLoading();
					$scope.selected = _.merge({}, $scope.search);
					ProductService.setSearchFilters($scope.search);
					$scope.searchResults = ProductService.searchResults = results;
				}, function(err) {
					console.error('Unable to get search results', err);
				});

			return false;
		}



	}
]);

// header search controller
controllers.controller('HeaderController', [
	'$scope',
	'$state',
	'ProductService',
	'Analytics',
	function($scope, $state, ProductService, Analytics) {

		var self = this;
		$scope.search = ProductService.search || {};

		$scope.toggleSearch = function($event) {
			$scope.showSearch = !$scope.showSearch;
		}

		self.reset = function() {
			$scope.showSearch = false;
			$scope.showMobileMenu = false;
		}
		self.reset();


		$scope.doSearch = function() {
			if ($scope.search.name) {
				// Reset the search results
				ProductService.searchResults = null;
				ProductService.setSearchFilters($scope.search);
				Analytics.trackEvent('website', 'header-search', 'filters', $scope.search);

				$scope.showSearch = false;
				$state.go('products');
			}
		}

		$scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
			// hide the expanded mobile menu
			self.reset();
		});

	}
]);

// for subscription
controllers.controller('SubscribeController', [
	'$scope',
	'ClientService',
	'Analytics',
	function($scope, ClientService, Analytics) {

		$scope.formData = {};

		$scope.subscribe = function() {
			$scope.submitting = true;

			Analytics.trackEvent('website', 'subscription', 'data', $scope.formData);

			ClientService.add($scope.formData).then(function(response) {
				$scope.submitting = false;
				console.log('response', response);
				if (response.submitted) {
					$scope.status = response.status;
					$scope.submitted = true;
				}
			});
		}

	}
]);



/*****************
 ** WEBPACK FOOTER
 ** ./js/controllers.js
 ** module id = 3
 ** module chunks = 0
 **/